var n = "_infoContainer_k2olb_1",
  o = {
    infoContainer: n
  };
export { o as default, n as infoContainer };